import { useContext, useEffect, useState } from "react";
import { ArrayFieldTemplateProps } from "@rjsf/utils";
import {
  Backspace,
  CaretDown,
  CaretUp,
  PlusCircle,
} from "@phosphor-icons/react";
import { EditActionContext } from "../actions/edit/EditActionContext";
import { Dog } from "@phosphor-icons/react/dist/ssr";

function PetArrayFieldTemplate(props: ArrayFieldTemplateProps) {
  const { className, items, canAdd, onAddClick } = props;

  // Estado para gestionar el colapso de cada elemento.
  const [openIndexes, setOpenIndexes] = useState<{ [key: number]: boolean }>(
    {}
  );

  const { backendFormErrors } = useContext(EditActionContext);

  // Función para alternar el estado abierto/cerrado de un elemento.
  const toggleCollapse = (index: number) => {
    setOpenIndexes((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const customAddClick = () => {
    // Vamos a añadir un nuevo elemento al openIndexes con valor a true para que aparezca abierto.
    const newIndex = items.length;
    setOpenIndexes((prev) => ({
      ...prev,
      [newIndex]: true,
    }));
    onAddClick();
  };

  useEffect(() => {
    // Si hay errores en el formulario, expandimos los elementos con errores
    if (backendFormErrors) {
      // newOpenIndexes debe ser una copia de openIndexes
      const newOpenIndexes = { ...openIndexes };
      items.forEach((element, index) => {
        if (backendFormErrors["pets"]?.[element.index]) {
          newOpenIndexes[index] = true;
        }
      });
      setOpenIndexes(newOpenIndexes);
    }
  }, [backendFormErrors, items]);

  return (
    <div className={className}>
      {/* Cabecera con el título y el botón */}
      <div
        className="d-flex justify-content-between align-items-center mb-3"
        style={{ marginTop: "-2.6rem" }}
      >
        {/* Título a la izquierda */}
        <div></div>

        {/* Botón para añadir mascotas a la derecha */}
        {canAdd && (
          <button
            className="btn btn-outline-primary"
            onClick={customAddClick}
            type="button"
          >
            <PlusCircle size={25}></PlusCircle>
            Añadir mascota
          </button>
        )}
      </div>

      {/* Contenedor principal */}
      <div>
        {/* Listado de mascotas */}
        <div
          className="card-body"
          style={{
            paddingTop: "0",
            maxHeight: "500px", // Aproximadamente 5 elementos de altura
            height: "500px", // Aproximadamente 5 elementos de altura
            overflowY: "auto",
          }}
        >
          {items &&
            items.map((element) => (
              <div
                key={element.key}
                className={`card mb-3 ${
                  !openIndexes[element.index] ? "collapsed-card" : ""
                }`}
              >
                {/* Cabecera de la tarjeta */}
                <div
                  className="card-header d-flex justify-content-between align-items-center"
                  style={{
                    padding: openIndexes[element.index] ? "1rem" : "0.5rem", // Cambiar el padding si está colapsado
                    fontSize: openIndexes[element.index] ? "1rem" : "0.85rem", // Reducir el tamaño del texto cuando está colapsado
                    cursor: "pointer",
                  }}
                  onClick={() => toggleCollapse(element.index)}
                >
                  {/* Nombre de la mascota */}
                  <div className="h4 ms-3">
                    <Dog size={25} className="me-3" />
                    {element.children?.props?.formData?.name} (
                    {element.children?.props?.formData?.breed})
                  </div>

                  {/* Iconos de eliminar (en rojo) y colapsar */}
                  <div className="d-flex align-items-center">
                    <span
                      onClick={element.onDropIndexClick(element.index)}
                      style={{
                        cursor: "pointer",
                        marginRight: "10px",
                        color: "#e50000",
                      }} // Icono de borrado en rojo
                    >
                      <Backspace size={32} />
                    </span>
                    <span>
                      {openIndexes[element.index] ? (
                        <CaretUp size={32} />
                      ) : (
                        <CaretDown size={32} />
                      )}
                    </span>
                  </div>
                </div>

                {/* Cuerpo de la tarjeta, colapsable */}
                {openIndexes[element.index] && (
                  <div className="card-body">{element.children}</div>
                )}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default PetArrayFieldTemplate;
